/*
*
* File JS componente Hero HP
*
*/


// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import ScrollMagic from 'ScrollMagic';
import 'debug.addIndicators';
import 'swiper/css/bundle';
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

//--------------------------------------------------------------------//


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './hero-hp.scss';

//--------------------------------------------------------------------//


// JS SPECIFICO COMPONENTE
//--------------------------------------------------------------------//

const initSwiper = () => {
    let sliderHP = document.querySelector('.hero-hp .swiper-container');

    if (!sliderHP) return;

    let pagination = sliderHP.querySelector('.hero-hp__pagination');
    let navPrev = sliderHP.querySelector('.hero-hp__wrap-nav .swiper-button-prev');
    let navNext = sliderHP.querySelector('.hero-hp__wrap-nav .swiper-button-next');

    Swiper.use([Navigation, Pagination, Autoplay]);

    const args = {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        speed: 600,
        autoplay: {
            delay: 5000,
        },
        pagination: {
            el: pagination,
            type: 'bullets',
        },
        navigation: 
        {
            nextEl: navNext,
            prevEl: navPrev,
        },
        a11y: {
            enabled: true,
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            notificationClass: 'swiper-notification'
        },
    };

    new Swiper(sliderHP, args);
}

const manageAnimation = () => {
    let triggerEl = document.querySelector('.hero-hp');

    if (!triggerEl) return;

    let sceneHero = null;
    let controller = new ScrollMagic.Controller();
    let durationScene = triggerEl.offsetHeight / 2;

    sceneHero = new ScrollMagic.Scene({
        triggerElement: triggerEl,
        offset: durationScene,
        triggerHook: 1,
        duration: durationScene
    })
    // .addIndicators()
    .on('progress', function(evt){

        let clipValue = 100 - (evt.progress * 100);

        if (clipValue > 0)
        {
            triggerEl.style.visibility = 'visible';
        } 
        else
        {
            triggerEl.style.visibility = 'hidden';
        }

        triggerEl.querySelector('.hero-hp__wrap-slider').style.clipPath = `circle(${clipValue}%)`;
    })
    .addTo(controller);
}

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const heroHp = () => {

    initSwiper();
    manageAnimation();

}

export default heroHp;

//--------------------------------------------------------------------//